
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import PendoLoadingIndicator from './pendo-loading-indicator.js';
import PendoEmptyState from './pendo-empty-state.js';

const defaults = {
  emptyIconColor: '#2A2C35',
  emptyIconSize: 36,
  emptyIconType: 'alert-circle',
  emptySubtext: 'Data will appear as usage occurs. Consider adjusting any applied filters.',
  emptyText: 'No Data Available',
  errorIconColor: '#DB1111',
  errorIconSize: 36,
  errorIconType: 'minus-circle',
  errorSubtext: 'Looks like something went wrong. Try reloading the page or contacting support if this issue continues.',
  errorText: 'Loading Error',
  loadingSubtext: null,
  loadingText: null,
  loadingType: 'material',
  loadingSpinnerSize: 36,
  loadingSpinnerBackground: '#FFFFFF',
  loadingSpinnerColor: undefined
};
const LOADING_STATES = {
  LOADING: 'loading',
  REJECTED: 'rejected',
  EMPTY: 'empty'
};
var script = {
  name: 'PendoStatusOverlay',
  components: {
    PendoLoadingIndicator,
    PendoEmptyState
  },
  props: {
    state: {
      type: String,
      default: null
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      LOADING_STATES
    };
  },

  computed: {
    config() {
      return _objectSpread({}, defaults, this.options);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-status-overlay",
    class: {
      'is-loading': _vm.state === _vm.LOADING_STATES.LOADING,
      'is-empty': _vm.state === _vm.LOADING_STATES.EMPTY,
      'is-rejected': _vm.state === _vm.LOADING_STATES.REJECTED
    }
  }, [_vm.state === _vm.LOADING_STATES.LOADING ? _c('pendo-loading-indicator', {
    staticClass: "pendo-status-overlay__loading-indicator",
    attrs: {
      "skeleton-props": {
        height: 24
      },
      "spinner-props": {
        size: _vm.config.loadingSpinnerSize,
        background: _vm.config.loadingSpinnerBackground,
        color: _vm.config.loadingSpinnerColor
      },
      "prevent-relative-parent": true,
      "loading": true,
      "type": _vm.config.loadingType,
      "text": _vm.config.loadingText
    }
  }) : _vm._e(), _vm._v(" "), _vm.config.loadingSubtext ? _c('span', [_vm._v("\n        " + _vm._s(_vm.config.loadingSubtext) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.state === _vm.LOADING_STATES.EMPTY ? _c('pendo-empty-state', {
    attrs: {
      "icon": {
        type: _vm.config.emptyIconType,
        size: _vm.config.emptyIconSize,
        stroke: _vm.config.emptyIconColor
      },
      "title": _vm.config.emptyText,
      "description": _vm.config.emptySubtext
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_vm._t("emptyActions")];
      },
      proxy: true
    }], null, true)
  }) : _vm._e(), _vm._v(" "), _vm.state === _vm.LOADING_STATES.REJECTED ? _c('pendo-empty-state', {
    attrs: {
      "icon": {
        type: _vm.config.errorIconType,
        size: _vm.config.errorIconSize,
        stroke: _vm.config.errorIconColor
      },
      "title": _vm.config.errorText,
      "description": _vm.config.errorSubtext
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_vm._t("errorActions")];
      },
      proxy: true
    }], null, true)
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-status-overlay.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoStatusOverlay = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoStatusOverlay;
